import { Injectable } from '@angular/core';
import { KalturaClient, MediaAddAction, KalturaMediaEntry, KalturaMediaType } from 'kaltura-ngx-client';
import { Observable } from 'rxjs';
import { cancelOnDestroy, tag } from '@kaltura-ng/kaltura-common';

import { AppLocalization } from '@kaltura-ng/mc-shared';

export interface DraftEntry {
  id: string;
}

@Injectable()
export class PrepareEntryService {
  constructor(private _kalturaServerClient: KalturaClient, private _appLocalization: AppLocalization) {}

  public createDraftEntry(mediaType: KalturaMediaType, conversionProfileId?: number): Observable<DraftEntry> {
    const entry: KalturaMediaEntry = new KalturaMediaEntry({
      name: this._appLocalization.get('applications.upload.uploadMenu.createDraft.draftEntry'),
      mediaType,
    });

    if (conversionProfileId) {
      entry.conversionProfileId = conversionProfileId;
    }

    return this._kalturaServerClient
      .request(new MediaAddAction({ entry }))
      .map((media) => ({ id: media.id }))
      .catch((error) =>
        // re-throw the provided error
        Observable.throw(new Error('Unable to create draft entry')),
      );
  }
}
